import { Grid, makeStyles } from '@material-ui/core';
import { useState } from 'react'
import { createNotes, getcreatenote } from '../apis';
import Button from '../components/Button';
import Template from '../components/Template';
import { useFormik } from "formik";
import useToken from "../hooks/useToken";
import {getNotesAttachments} from "../apis";
import {commonStrings} from "../components/StringBundle";
import Snackbar from '../components/Snackbar';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            marginTop: 10,
        },
        '& .MuiFormControl-fullWidth': {
            width: '95%'
        },
        '& .page-header': {
            width: '100%',
            marginBottom: 15,
        },
        '& .MuiAccordion-root': {
            width: '100%'
        },
        '& .dispatchTable': {
            maxHeight: '400px',
            overflowY: "auto",
        },
        flexGrow: 1,
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
    }
}));

function AddNote(props) {
    const { closeModal, label, sampleId, setNotes,notes,requestType,netsuiteid, order_id } = props;
    const classes = useStyles();
    const { getCurrentUserDetails } = useToken();
    const currentUserDetails = getCurrentUserDetails();
    const initialValues = {
        title: "",
        description: "",
        parentId: sampleId,
        createdBy: currentUserDetails.name,
        // note:"11"
    }
    const [showSnack, setSnack] = useState({});
    
    // Snackbar close function
    const snackbarClose = () => {
        setSnack({ open: false, message: "", severity: "" });
    };

    const onSubmit = async (values) => {
        try {
            const res = await getcreatenote(values);
            setNotes(res);
            closeModal();
            const requesttype = 'orderDispatch';
            const recordid = sampleId;
            const netsuite = netsuiteid == "" ? null : netsuiteid;
            if(order_id){
            getNotesAttachments(requesttype, recordid, netsuite);
            }
        }
        catch (error) {
            console.error(error);
            setSnack({ open: true, message: commonStrings.serverError, severity: commonStrings.error });
        }
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: onSubmit,
        enableReinitialize: true
    })

    const payload = [
        {
            id: "title",
            name: "title",
            label: 'Title',
            type: 'input',
            required: true,
            value: formik.values.title,
            onChange: formik.handleChange,
            sm: 12
        },
        {
            id: "description",
            name: "description",
            label: "Description",
            type: 'input',
            rows: 3,
            multiline: true,
            required: true,
            value: formik.values.description,
            onChange: (e) => {
                if (e.target.value.length <= 999) {
                    formik.handleChange(e);
                } else {
                    setSnack({ open: true, message: commonStrings.descriptionLimit, severity: commonStrings.snackSeverityWarning });   
                }
            },
            sm: 12,
        }
    ]

    return (
        <>
            {showSnack.open && (<Snackbar {...showSnack} handleClose={snackbarClose} />)}
            <form className={classes.root} onSubmit={formik.handleSubmit} noValidate autoComplete="off">
                <Grid container md={12} xs={12}>
                    <Grid item md={12} xs={12}>
                        <Template payload={payload} />
                    </Grid>
                </Grid>
                <Grid container xs={12} md={12} style={{ marginTop: 24 }} justify="center">
                    <Grid item>
                        <Button label="Save" type="submit" disabled={!formik.values.title || !formik.values.description} />
                    </Grid>
                    <Grid item>
                        <Button label="Cancel" onClick={closeModal} />
                    </Grid>
                </Grid>
            </form>
        </>
    )
}

export default AddNote